import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import CircularProgress from '@mui/material/CircularProgress';

import {
  Box,
  Button,
  Chip,
  Collapse,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  styled,
  TableBody,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaPhone } from "react-icons/fa";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Row from "react-bootstrap/Row";
import {
  FaBlenderPhone,
  FaEdit,
  FaPhoneSquare,
  FaTrash,
  FaEye,
  FaWindowClose,
} from "react-icons/fa";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Fade from "@mui/material/Fade";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import axios from "axios";
import Pagination from "@mui/material/Pagination";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import moment from "moment";
import { FaMobileAlt } from "react-icons/fa";
import Badge from "react-bootstrap/Badge";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { FormControl } from "react-bootstrap";
import { Payment } from "@material-ui/icons";
import { FiChevronDown, FiChevronUp, FiDownloadCloud, FiSmartphone } from "react-icons/fi";


const PreSales = () => {
  const [value, setValue] = React.useState("1");
  const [id, setId] = useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //   const add_blockform = () => {
  //     console.log({
  //       name: nname,
  //       mobile: nmobile,
  //       alternateMobile: alternatemob,
  //       email: nemail,
  //       permanentAddress: peraddress,
  //       addComm: addresscom,
  //       aadharNo: aadharnumber,
  //       panNo: pannumber,
  //       paySource: paymentsource,
  //       cheqNo: chequenumber,
  //       transferDetail: transferdetails,
  //       amtInWords: amountinwords,
  //       amt: Amount,
  //       tflatNo: tflatno,
  //       ttowerNo: ttowerno,
  //       salesSOurce: salessource,
  //     });
  //     const formdata = new FormData();
  //     formdata.append("name", nname);
  //     formdata.append("mobile", nmobile);
  //     formdata.append("alternateMobile", alternatemob);
  //     formdata.append("email", nemail);
  //     formdata.append("permanentAddress", peraddress);
  //     formdata.append("addComm", addresscom);
  //     formdata.append("aadharNo", aadharnumber);
  //     formdata.append("panNo", pannumber);
  //     formdata.append("paySource", paymentsource);
  //     formdata.append("cheqNo", chequenumber);
  //     formdata.append("transferDetail", transferdetails);
  //     formdata.append("amtInWords", amountinwords);
  //     formdata.append("amt", Amount);
  //     formdata.append("tflatNo", tflatno);
  //     formdata.append("ttowerNo", ttowerno);
  //     formdata.append("salesSOurce", salessource);
  //     formdata.append("sig", signature);
  //     axios
  //       .post(
  //         "https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform",
  //         formdata
  //       )
  //       .then((res) => {
  //         if (res.data.status === 200) {
  //           setOpenbf(false);
  //           customerObjsib();
  //           Swal.fire({
  //             icon: "success",
  //             title: "Success !",
  //             text: "Data is added successfully !",
  //             confirmButtonColor: "rgb(126, 110, 228)",
  //             cancelButtonColor: "#d33",
  //             showCancelButton: false,
  //             confirmButtonText: "Ok",
  //           }).then((result) => {
  //             if (result.value) {
  //               return;
  //             }
  //           });
  //         }
  //       });
  //   };


 
  const [customerRessib, setCustomerResponsesib] = React.useState([]);

  const customerObjsib = () => {
    axios
      .get("https://buildfastvapi.emedha.in/create-customer/api/v1/getblockform")
      .then((res) => {
        setCustomerResponsesib(res.data);
        console.log(res.data)
      });
  };

  console.log(customerRessib)

  const [customerRes, setCustomerResponse] = React.useState([]);

  // https://buildfastvapi.emedha.in/create-customer/api/v1/customers

  const customerObj = () => {
    axios
      .get("https://buildfastvapi.emedha.in/create-customer/api/v1/customers")
      .then((res) => {
        setCustomerResponse(res.data);
        console.log(res.data)
      });
  };

  React.useEffect(() => {
    customerObj();
    customerObjsib();
  }, []);


  console.log(customerRes)

  const [openRejectForm, setOpenReject] = React.useState();

  const handleClickOpenReject = () => {
    setOpenReject(true);
  };

  const handleCloseReject = () => {
    setOpenReject(false);
  };

  const [rejectDate, setDataForReject] = useState("");
  const [rejectComment, setCommentForReject] = useState("");

  const [Validatedtabcb, setValidatedtabcb] = useState(false);

  const formValidationReject = async(event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
       try {
        await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/block/reject', {
          id,
          rejectDate: rejectDate,
          rejectComment: rejectComment,
       
        });
        setDataForReject({});
        setCommentForReject('');
        setDataForReject('')
        setOpenReject(false);
        alert("Block Successfully Rejected")
        window.location.reload();
      } catch (error) {
        console.error("Error approving blocked customer:", error);
        alert("Error approving blocked customer:", error)
      }
      setValidatedtabcb(false);
    };
  };

  const [openBookRejectForm, setOpenBookRejectForm] = useState();

  const handleClickBookingReject = () => {
    setOpenBookRejectForm(true);
  };

  const handleCloseBookReject = () => {
    setOpenBookRejectForm(false);
  };

  const [bookingRejectDate, setDataForBookingReject] = useState("");
  const [bookingRejectComment, setCommentForBookingReject] = useState("");

  const formValidationRejectBook = async(event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      try {
        await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/book/reject', {
          id,
          rejectDate: bookingRejectDate,
          rejectComment: bookingRejectComment,
       
        });
        setDataForBookingReject({});
        setCommentForBookingReject('');
        setDataForBookingReject('')
        setOpenBookRejectForm(false);
        alert("Book Successfully Rejected")
        window.location.reload();
      } catch (error) {
        console.error("Error approving blocked customer:", error);
        alert("Error approving booked customer:", error)
      }
      setValidatedtabcb(false);
    };
    
  };

  const [blockApproveDate, setDataForBlockApprove] = useState("");
  const [blockApproveComment, setCommentForBlockApprove] = useState("");
  const [blockTransactionId,setTransactionIdForApproveBlock]=useState("")
  const [blockedCustomers, setBlockedCustomers] = useState(customerRessib);

  const [ValidatedtaBlockApproveForm, setValidatedBlockApproveForm] = useState(false);

  const [openApproveBlockForm, setOpenApproveBlockForm] = useState();

  const handleClickOpenApproveBlock = () => {
    setOpenApproveBlockForm(true);
  };

  const handleCloseApproveBlockForm = () => {
    setOpenApproveBlockForm(false);
  };

  const formValidationForBlockApprove =async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      try {
        await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/block/approve', {
          id,
          approvalDate: blockApproveDate,
          comment: blockApproveComment,
          transactionId:blockTransactionId
        });

        // https://buildfastvapi.emedha.in/create-customer/api/v1/block/approve
        // Update the blocked and booking lists
        // const updatedBlockedCustomers = blockedCustomers.filter(item => item.Id !== approveData.Id);
        // const updatedCustomers = [...customers, { ...approveData, status: 'Approved' }];
        // setBlockedCustomers(updatedBlockedCustomers);
        // setCustomers(updatedCustomers);
        setApproveData({});
        setCommentForBlockApprove('');
        setDataForBlockApprove('')
        setOpenApproveBlockForm(false);
        alert("Block Successfully Approved")
        window.location.reload();
      } catch (error) {
        console.error("Error approving blocked customer:", error);
        alert("Error approving blocked customer:", error)
      }
      setValidatedBlockApproveForm(false);
    }
    
  };


   
  const [clickedName, setClickedName] = useState(sessionStorage.getItem("clickedName") || "")

  const handleRowClickItem = (itemName) => {
    sessionStorage.setItem("clickedName", itemName);
    setClickedName(itemName);
    console.log("Stored clicked name:", itemName); // Debug log
  };

  // const clickedName = sessionStorage.getItem("clickedName");
  // console.log("Retrieved clicked name:", clickedName); // Debug log

  React.useEffect(() => {
    const storedName = sessionStorage.getItem("clickedName");
    if (storedName) {
      setClickedName(storedName);
    }
  }, []);


  const filteredItems = clickedName
    ? customerRessib.filter((item) => item.name === clickedName)
    : [];

    console.log(filteredItems)





  const [bookDateApprove, setDataForApproveBooking] = useState("");
  const [bookCommentApprove, setCommentForApproveBooking] = useState("");
  const [bookTransactionId,setTransactionIdForApproveBooking]= useState("");

  const [openApproveBookingForm, setApproveBookingForm] = useState("");
  
  const [ValidatedtaBookingForm, setValidatedBookingForm] = useState(false);
  const [approveData, setApproveData] = useState({});

  const handleClickBookingApprove = (item) => {
    setApproveBookingForm(true);
    setApproveData(item);
  };

  const handleCloseApproveBookingForm = () => {
    setApproveBookingForm(false);
  };

  const formValidationApproveBookingForm = async(event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
     

      //https://buildfastvapi.emedha.in/create-customer/api/v1/book/approve

      try{
        await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/book/approve', {
          id,
          approvalDate: bookDateApprove,
          comment: bookCommentApprove,
          // transactionId:bookTransactionId
        });
       
       
        setApproveData({});
        setCommentForApproveBooking('');
        setDataForApproveBooking('')
        setApproveBookingForm(false)
        alert("Booking Successfully Approved")
        window.location.reload();
      } catch (error) {
        // Handle error, e.g., show error message
        console.error("Error approving booking:", error);
        alert("Error approving booking customer:", error)
      }
      setValidatedBookingForm(false);
    }
    
  };


  const getCurrentDateTime = () => {
    const current = new Date();
    const year = current.getFullYear();
    const month = String(current.getMonth() + 1).padStart(2, "0");
    const day = String(current.getDate()).padStart(2, "0");
    const hours = String(current.getHours()).padStart(2, "0");
    const minutes = String(current.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // Set the default date and time when the component mounts
  React.useEffect(() => {
    setDataForBlockApprove(getCurrentDateTime());
    setDataForApproveBooking(getCurrentDateTime())
    
  }, []);

  const [openRows, setOpenRows] = useState({});

  // Toggle row expansion
  const handleRowClick = (id) => {
    setOpenRows(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  const [clickedNameBook, setClickedNameBook] = useState(sessionStorage.getItem("clickedNamebOOK") || "")

  const handleRowClickItemBook = (itemName) => {
    sessionStorage.setItem("clickedNamebOOK", itemName);
    setClickedNameBook(itemName);
    console.log("Stored clicked name:", itemName); // Debug log
  };

  // const clickedName = sessionStorage.getItem("clickedName");
  // console.log("Retrieved clicked name:", clickedName); // Debug log

  React.useEffect(() => {
    const storedName = sessionStorage.getItem("clickedNamebOOK");
    if (storedName) {
      setClickedNameBook(storedName);
    }
  }, []);


  const filteredItemsBook = clickedNameBook
    ? customerRes.filter((item) => item.customerName === clickedNameBook)
    : [];

    console.log(filteredItemsBook)


  // const updatePayment = (id, paymentType, status, approvalDate, comment) => {
  //   const url = `http://localhost:3003/api/payments/${id}/${paymentType}/${status}`;
  //   axios.post(url, { approvalDate, comment })
  //     .then(response => {
  //       console.log('Success:', response.data);
  //       // Update local state or refetch data
  //     })
  //     .catch(error => {
  //       console.error('Error:', error);
  //     });
  // };

  // https://buildfastvapi.emedha.in/create-customer/api/v1/api/payments/${id}/${type}/${action}

  const updatePayment = async (id, type, action, approvalDate, comment) => {
    try {
      const response = await fetch(`https://buildfastvapi.emedha.in/create-customer/api/v1/api/payments/${id}/${type}/${action}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ approvalDate, comment }),
      });
      const result = await response.json();
      if (response.ok) {
        alert(`Success: ${result.message}`);
      } else {
        alert(`Failed to update payment: ${result.error}`);
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };
  
  
  const [inputValues, setInputValues] = useState({});

  const handleInputChange = (id, type, field, value) => {
    setInputValues(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [`${type}_${field}`]: value
      }
    }));
  };

  const [paymentStatus, setPaymentStatus] = useState({});


  const handleApproveReject = async (id, type, action) => {
    const item = inputValues[id] || {};
    const approvalDate = item[`${type}_approvalDate`] || '';
    const comment = item[`${type}_comment`] || '';

    await updatePayment(id, type, action, approvalDate, comment);
    setPaymentStatus(prevStatus => ({
      ...prevStatus,
      [id]: {
        ...prevStatus[id],
        [type]: action === 'approve' ? 'Approved' : 'Rejected',
      },
    }));
  };


  const customerName = filteredItemsBook.customerName;
  const payments = filteredItemsBook.payments || [];

  console.log(customerName)
  console.log(payments)


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // // const handleApproval = async (itemIndex, paymentIndex) => {
  // //   setLoading(true);
  // //   setError(null);

  // //   const payment = filteredItemsBook[itemIndex].payments[paymentIndex];

  // //   try {
  // //     const response = await axios.post('http://localhost:3003/api/approvePayment', {
  // //       id: payment.id,
     
  // //       paidStatus: 'Approved'
  // //     });

  // //     if (response.status === 200) {
  // //       const updatedFilteredItemsBook = [...filteredItemsBook];
  // //       updatedFilteredItemsBook[itemIndex].payments[paymentIndex].paidStatus = 'Approved';
       
  // //       setFilteredItemsBook(updatedFilteredItemsBook);
  // //     }
  // //   } catch (err) {
  // //     setError('Failed to approve payment. Please try again.');
  // //   } finally {
  // //     setLoading(false);
  // //   }
  // // };

  // const handleApproval = async (itemIndex, paymentIndex) => {
  //   setLoading(true);
  //   setError(null);
  
  //   const payment = filteredItemsBook[itemIndex].payments[paymentIndex];
  
  //   try {
  //     const response = await axios.post('http://localhost:3003/api/approvePayment', {
  //       id: payment.id,
  //       paidStatus: 'Approved'
  //     });
  
  //     console.log('Response:', response); // Debugging line
  
  //     if (response.status === 200) {
  //       const updatedFilteredItemsBook = [...filteredItemsBook];
  //       updatedFilteredItemsBook[itemIndex].payments[paymentIndex].paidStatus = 'Approved';
  //       updatedFilteredItemsBook[itemIndex].payments[paymentIndex].status = 'Approved';
  
       
  //     } else {
  //       setError('Unexpected response status. Please try again.');
  //     }
  //   } catch (err) {
  //     console.error('Error approving payment:', err.response ? err.response.data : err.message);
  //     setError('Failed to approve payment. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // const handleRejection = async (itemIndex, paymentIndex) => {
  //   setLoading(true);
  //   setError(null);

  //   const payment = filteredItemsBook[itemIndex].payments[paymentIndex];

  //   try {
  //     const response = await axios.post('http://localhost:3003/api/rejectPayment', {
  //       id: payment.id,
   
  //       paidStatus: 'Rejected'
  //     });

  //     if (response.status === 200) {
  //       const updatedFilteredItemsBook = [...filteredItemsBook];
  //       updatedFilteredItemsBook[itemIndex].payments[paymentIndex].paidStatus = 'Rejected';
     
  //       setFilteredItemsBook(updatedFilteredItemsBook);
  //     }
  //   } catch (err) {
  //     setError('Failed to reject payment. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const DownloadLink = styled('a')({
    display: 'inline-block',
    textDecoration: 'none',
    color: '#007bff',
    margin: '0.5rem 0',
  });



  // Function to handle approval
  const handleApproval = async (itemIndex, paymentIndex) => {
    setLoading(true);
    setError(null);
  
    const payment = filteredItemsBook[itemIndex].payments[paymentIndex];

    // https://buildfastvapi.emedha.in/create-customer/api/v1/api/approvePayment
  
    try {
      const response = await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/api/approvePayment', {
        id: payment.id,
        paidStatus: 'Approved'
      });
  
      if (response.status === 200) {
        // Update state to remove the payment
        const updatedFilteredItemsBook = [...filteredItemsBook];
        updatedFilteredItemsBook[itemIndex].payments = updatedFilteredItemsBook[itemIndex].payments.filter(
          (_, index) => index !== paymentIndex
        );
        
        // Optionally, remove the item if it has no payments left
        if (updatedFilteredItemsBook[itemIndex].payments.length === 0) {
          updatedFilteredItemsBook.splice(itemIndex, 1);
        }
  
        // setFilteredItemsBook(updatedFilteredItemsBook);
        setApproveBookingForm(false); // Close dialog after approval
        alert('Payment approved successfully.'); // Success alert
      } else {
        setError('Unexpected response status. Please try again.');
      }
    } catch (err) {
      console.error('Error approving payment:', err.response ? err.response.data : err.message);
      setError('Failed to approve payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  // Function to handle rejection
  const handleRejection = async (itemIndex, paymentIndex) => {
    setLoading(true);
    setError(null);
  
    const payment = filteredItemsBook[itemIndex].payments[paymentIndex];

    // https://buildfastvapi.emedha.in/create-customer/api/v1/api/rejectPayment
  
    try {
      const response = await axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/api/rejectPayment', {
        id: payment.id,
        paidStatus: 'Rejected'
      });
  
      if (response.status === 200) {
        // Update state to remove the payment
        const updatedFilteredItemsBook = [...filteredItemsBook];
        updatedFilteredItemsBook[itemIndex].payments = updatedFilteredItemsBook[itemIndex].payments.filter(
          (_, index) => index !== paymentIndex
        );
        
        // Optionally, remove the item if it has no payments left
        if (updatedFilteredItemsBook[itemIndex].payments.length === 0) {
          updatedFilteredItemsBook.splice(itemIndex, 1);
        }
  
        alert('Payment rejected successfully.'); 
        setApproveBookingForm(false); // Close dialog after rejection
      } else {
        setError('Unexpected response status. Please try again.');
      }
    } catch (err) {
      console.error('Error rejecting payment:', err.response ? err.response.data : err.message);
      setError('Failed to reject payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };




  const handleRowClickToggle = (id) => {
    setOpenRows(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Paginated data
  const filteredCustomerRes = customerRes
    .filter(item => item.payments.some(payment => payment.paidStatus === 'Rejected' || payment.paidStatus === 'Approved'));

  const paginatedData = filteredCustomerRes
    .flatMap(item => item.payments
      .filter(payment => payment.paidStatus === 'Rejected' || payment.paidStatus === 'Approved')
      .map(payment => ({ ...payment, customerName: item.customerName, flatNo: item.flatNo }))
    )
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


    const filteredTransactionDetails = customerRessib
    .filter(item => {
      // Only show detailed transactions for blocked items
      return (
        item.overall_status === 'Approved' || item.overall_status === 'Rejected' &&
        (item.bank_amtPaid || item.cheque_amtPaid || item.online_amtPaid || item.upi_amtPaid)
      );
    });

  // Paginated data
  const paginatedTransactionDetails = filteredTransactionDetails
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const setCloseFunction=()=>{
      window.location.reload()
    }
  

    const ProjectName=sessionStorage.getItem("ProjectName")

  return (
    <>
      <div>
        {
          <div className="leadManagementTable">
            <Typography
              style={{
                color: "rgba(41, 16, 105, 1)",
                marginBottom: 6,
                marginLeft: 15.5,
                fontSize: 18,
                color: "gray",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              PreSales Details
            </Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 5,
              }}
            ></div>
            <Paper elevation={0}>
              {/* <TableContainer sx={{ height: 95 + "vh", p: 0.3, pt: 2 }} > */}

              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: "divider",
                      color: "rgb(86, 63, 146)",
                    }}
                  >
                  <TabList
  onChange={handleChange}
  aria-label="premium status tabs"
  TabIndicatorProps={{
    sx: {
      backgroundColor: "#4318ff", // Premium purple indicator
      height: "3px", // Thicker, modern bottom line
      borderTopLeftRadius: "3px", // Slightly rounded indicator edges
      borderTopRightRadius: "3px",
    }
  }}
  sx={{

    mb: 3, // Breathing room below the tabs
  }}
>
  <Tab
    label="Blocked"
    value="1"
    disableRipple // Removes the old Android-style ripple effect for a snappier SaaS feel
    sx={{
      textTransform: "none", // Uses "Blocked" instead of "BLOCKED"
      fontWeight: "700",
      fontSize: { xs: "14px", md: "15px" }, // Slightly smaller on phones, larger on desktop
      color: "#A3AED0", // Premium muted gray when inactive
      minWidth: { xs: "50%", sm: "120px" }, // Takes up exactly half the screen on phones, compact on desktop
      transition: "color 0.2s ease",
      "&.Mui-selected": {
        color: "#4318ff", // Deep purple when clicked
      },
    }}
  />
  <Tab
    label="Booked"
    value="2"
    disableRipple
    sx={{
      textTransform: "none",
      fontWeight: "700",
      fontSize: { xs: "14px", md: "15px" },
      color: "#A3AED0",
      minWidth: { xs: "50%", sm: "120px" },
      transition: "color 0.2s ease",
      "&.Mui-selected": {
        color: "#4318ff",
      },
    }}
  />
</TabList>
                  </Box>
                
                  {/* <TabPanel value="1">
  <div style={{ width: "58rem" }}>
    <Typography
      style={{
        color: "rgba(41, 16, 105, 1)",
        marginBottom: 3,
        marginLeft: 15.5,
        fontSize: 18,
        color: "gray",
        fontWeight: "500",
        textAlign: "center",
      }}
    >
      Blocked
    </Typography>
    <div style={{ fontWeight: "bold" }}>
      Total Blocked: {customerRessib.filter(item => {
        // Exclude items where overall_status is 'Approved'
        if (item.overall_status === 'Approved') {
          return false;
        }
        
        // Check if any payment amount is provided
        const hasPayment = 
          item.bank_amtPaid ||
          item.cheque_amtPaid ||
          item.online_amtPaid ||
          item.upi_amtPaid;
        
        // Check if any payment method has been approved
        const hasApprovedPayment = 
          (item.bank_status === 'Approved' && item.bank_amtPaid) ||
          (item.cheque_status === 'Approved' && item.cheque_amtPaid) ||
          (item.online_status === 'Approved' && item.online_amtPaid) ||
          (item.upi_status === 'Approved' && item.upi_amtPaid);

          const projectnames=item.ProjectName===ProjectName
        
        // Exclude items where all payment amounts are missing or all payments are approved
        return hasPayment && !hasApprovedPayment && projectnames;
      }).length}
    </div>

    <Table style={{ position: "relative", top: "1.3rem" }}>
      <TableHead sx={{ borderTop: "1px solid lightgray" }}>
        <TableRow>
          <TableCell
            align={"start"}
            style={{
              minWidth: 0,
              fontSize: 14,
              fontWeight: "600",
            }}
          >
            Name
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 57, fontWeight: "600" }}
          >
            Mobile
          </TableCell>

          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Aadhar
          </TableCell>

          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Address
          </TableCell>

          <TableCell
            align={"center"}
            style={{ top: 21, fontWeight: "600", width: 18 }}
          >
            Action
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customerRessib &&
          customerRessib
            .filter(item => {
              // Exclude items where overall_status is 'Approved'
              if (item.overall_status === 'Approved') {
                return false;
              }
              
              // Check if any payment amount is provided
              const hasPayment = 
                item.bank_amtPaid ||
                item.cheque_amtPaid ||
                item.online_amtPaid ||
                item.upi_amtPaid;
              
              // Check if any payment method has been approved
              const hasApprovedPayment = 
                (item.bank_status === 'Approved' && item.bank_amtPaid) ||
                (item.cheque_status === 'Approved' && item.cheque_amtPaid) ||
                (item.online_status === 'Approved' && item.online_amtPaid) ||
                (item.upi_status === 'Approved' && item.upi_amtPaid);


                const ProjectNames=item.ProjectName===ProjectName
              
              // Exclude items where all payment amounts are missing or all payments are approved
              return hasPayment && !hasApprovedPayment && ProjectNames;
            })
            .map(item => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={item.id}
              >
                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.name}
                </TableCell>
                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  <button
                    style={{
                      fontSize: 10.7,
                      border: "2px solid rgb(126, 110, 228)",
                      backgroundColor: "white",
                      borderRadius: "1.2rem",
                      cursor: "auto",
                    }}
                  >
                    <FaMobileAlt
                      style={{
                        marginRight: 3,
                        color: "rgb(126, 110, 228)",
                        marginTop: "-0.16rem",
                        fontSize: 9,
                      }}
                    />
                    {item.mobile}
                  </button>
                </TableCell>

                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.aadharNo}
                </TableCell>

                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.permanentAddress}
                </TableCell>
                <TableCell
                  align="start"
                  style={{
                    top: 57,
                    fontSize: 12,
                    color: "rgb(126, 110, 228) ",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <Badge
                      bg="success"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleClickOpenApproveBlock();
                        handleRowClickItem(item.name);
                        setId(item.id);
                      }}
                    >
                      Approve
                    </Badge>
                  </div>
                </TableCell>
              </TableRow>
            ))}
      </TableBody>
    </Table>


    <Typography
      style={{
        color: "rgb(126, 110, 228)",
        marginBottom: 3,
        marginLeft: 15.5,
        fontSize: 18,
        marginTop:35,
        fontWeight: "500",
        textAlign: "center",
        marginTop: "2rem",
      }}
    >
      Transaction Details
    </Typography>
    <Table style={{ position: "relative", top: "1.3rem" ,marginBottom:30}}>
      <TableHead sx={{ borderTop: "1px solid lightgray" }}>
        <TableRow>
          <TableCell
            align={"start"}
            style={{
              minWidth: 0,
              fontSize: 14,
              fontWeight: "600",
            }}
          >
            Name
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 57, fontWeight: "600" }}
          >
            Email
          </TableCell>

          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Flat No
          </TableCell>

          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Payment Transactions
          </TableCell>

          <TableCell
            align={"center"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Status
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {paginatedTransactionDetails.filter((item=> item.ProjectName===ProjectName))
            .map(item => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={item.id}
              >
                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.name}
                </TableCell>
                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.email}
                </TableCell>

                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.tflatNo}
                </TableCell>

                <TableCell
                  align="start"
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.bank_amtPaid && `Bank: ₹${item.bank_amtPaid}`}
                  {item.cheque_amtPaid && `, Cheque: ₹${item.cheque_amtPaid}`}
                  {item.online_amtPaid && `, Online: ₹${item.online_amtPaid}`}
                  {item.upi_amtPaid && `, UPI: ₹${item.upi_amtPaid}`}
                </TableCell>
                <TableCell
  align="start"
  style={{
    top: 57,
    fontSize: 12,
    color: item.overall_status === 'Approved' ? 'green' : item.overall_status === 'Rejected' ? 'red' : 'black',
  }}
>
  {item.overall_status}
</TableCell>

              </TableRow>
            ))}
      </TableBody>
    </Table>
    <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredTransactionDetails.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
  </div>
</TabPanel> */}

{/* Make sure you import these at the top: */}
{/* import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Chip, TablePagination } from "@mui/material"; */}
{/* import { FiSmartphone } from "react-icons/fi"; */}

<TabPanel value="1" sx={{ p: { xs: 1, sm: 3 } }}> 
  {/* The sx padding above ensures it doesn't touch the screen edges on mobile */}
  
  <Box sx={{ width: "100%" }}>
    
    {/* ========================================================= */}
    {/* 1. DATA PREPARATION (Extracted for clean HTML)            */}
    {/* ========================================================= */}
    {(() => {
      // Safely filter Blocked Customers
      const blockedCustomersList = customerRessib ? customerRessib.filter(item => {
        if (item.overall_status === 'Approved') return false;
        
        const hasPayment = item.bank_amtPaid || item.cheque_amtPaid || item.online_amtPaid || item.upi_amtPaid;
        const hasApprovedPayment = 
          (item.bank_status === 'Approved' && item.bank_amtPaid) ||
          (item.cheque_status === 'Approved' && item.cheque_amtPaid) ||
          (item.online_status === 'Approved' && item.online_amtPaid) ||
          (item.upi_status === 'Approved' && item.upi_amtPaid);
        
        const isCurrentProject = item.ProjectName === ProjectName;
        
        return hasPayment && !hasApprovedPayment && isCurrentProject;
      }) : [];

      // Safely filter Transactions
      const filteredTransactionsList = paginatedTransactionDetails ? 
        paginatedTransactionDetails.filter(item => item.ProjectName === ProjectName) : [];

      return (
        <>
          {/* ========================================================= */}
          {/* 2. BLOCKED LEADS TABLE                                    */}
          {/* ========================================================= */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography sx={{ color: "#1B2559", fontSize: "18px", fontWeight: "800" }}>
              Blocked Leads
            </Typography>
            <Box sx={{ backgroundColor: "#FDF4FF", color: "#D946EF", px: 2, py: 0.5, borderRadius: "20px", fontSize: "12px", fontWeight: "700" }}>
              Total: {blockedCustomersList.length}
            </Box>
          </Box>

          <Paper elevation={0} sx={{ width: "100%", borderRadius: "12px", border: "1px solid #E0E5F2", overflow: "hidden", mb: 5 }}>
            <TableContainer sx={{ overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
              <Table sx={{ minWidth: 600 }}>
                <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                  <TableRow>
                    {["Name", "Mobile", "Aadhar", "Address", "Action"].map((head, idx) => (
                      <TableCell key={idx} align={head === "Action" ? "center" : "start"} sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {blockedCustomersList.map(item => (
                    <TableRow hover key={item.id}>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {item.name}
                      </TableCell>
                      <TableCell sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {/* Premium Phone Badge */}
                        <Chip 
                          icon={<FiSmartphone size={12} style={{ color: "#4318ff" }} />} 
                          label={item.mobile} 
                          size="small"
                          sx={{ backgroundColor: "#EEF2FF", color: "#4318ff", fontWeight: "600", fontSize: "11px", borderRadius: "8px" }}
                        />
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {item.aadharNo}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", minWidth: "150px" }}>
                        {item.permanentAddress}
                      </TableCell>
                      <TableCell align="center" sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2" }}>
                        <Button 
                          variant="contained" 
                          disableElevation
                          onClick={() => {
                            handleClickOpenApproveBlock();
                            handleRowClickItem(item.name);
                            setId(item.id);
                          }}
                          sx={{ backgroundColor: "#10B981", color: "white", fontSize: "11px", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2, py: 0.5, "&:hover": { backgroundColor: "#059669" } }}
                        >
                          Approve
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {blockedCustomersList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4, color: "#A3AED0", fontWeight: "600", fontSize: "13px" }}>No blocked leads found.</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          {/* ========================================================= */}
          {/* 3. TRANSACTION DETAILS TABLE                                */}
          {/* ========================================================= */}
          <Typography sx={{ color: "#1B2559", fontSize: "18px", fontWeight: "800", mb: 2 }}>
            Transaction Details
          </Typography>

          <Paper elevation={0} sx={{ width: "100%", borderRadius: "12px", border: "1px solid #E0E5F2", overflow: "hidden" }}>
            <TableContainer sx={{ overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
              <Table sx={{ minWidth: 700 }}>
                <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                  <TableRow>
                    {["Name", "Email", "Flat No", "Payment Transactions", "Status"].map((head, idx) => (
                      <TableCell key={idx} align="start" sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredTransactionsList.map(item => (
                    <TableRow hover key={item.id}>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {item.name}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {item.email}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "600", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {item.tflatNo}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {/* Joins available payments cleanly without awkward commas at the start/end */}
                        {[
                          item.bank_amtPaid && `Bank: ₹${item.bank_amtPaid}`,
                          item.cheque_amtPaid && `Cheque: ₹${item.cheque_amtPaid}`,
                          item.online_amtPaid && `Online: ₹${item.online_amtPaid}`,
                          item.upi_amtPaid && `UPI: ₹${item.upi_amtPaid}`
                        ].filter(Boolean).join(" • ") || "—"}
                      </TableCell>
                      <TableCell sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        <Box sx={{ 
                          display: "inline-block", px: 1.5, py: 0.5, borderRadius: "20px", fontSize: "11px", fontWeight: "700", textTransform: "uppercase",
                          backgroundColor: item.overall_status === 'Approved' ? "#F0FDF4" : item.overall_status === 'Rejected' ? "#FEF2F2" : "#F8FAFC",
                          color: item.overall_status === 'Approved' ? "#10B981" : item.overall_status === 'Rejected' ? "#DC2626" : "#64748B"
                        }}>
                          {item.overall_status || "Pending"}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                  {filteredTransactionsList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4, color: "#A3AED0", fontWeight: "600", fontSize: "13px" }}>No transactions found.</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredTransactionDetails?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ color: "#707eae", fontWeight: "600", borderTop: "1px solid #E0E5F2" }}
            />
          </Paper>

        </>
      );
    })()}
    
  </Box>
</TabPanel>

{/* 
<TabPanel value="2">
      <div style={{ width: "58rem" }}>
        <Typography
          style={{
            color: "rgba(41, 16, 105, 1)",
            marginBottom: 3,
            marginLeft: 15.5,
            fontSize: 18,
            color: "gray",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          Booked
        </Typography>

        <div style={{ fontWeight: "bold" }}>
          Total Booked: {customerRes
            .filter(item => item.payments.some(payment => payment.paidStatus === null) && item.ProjectName===ProjectName)
            .length}
        </div>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Name</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Mobile</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Loan</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Amount Paid</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Payments</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customerRes && customerRes
                .filter(item => item.payments.some(payment => payment.paidStatus === null) && item.ProjectName===ProjectName) // Filter for 'Received' payments
                .map((item) => {
                  const filteredPayments = item.payments.filter(payment => payment.paidStatus === null);
                  const totalAmountPaid = filteredPayments.reduce((sum, payment) => sum + parseFloat(payment.finalAmount || 0), 0);

                  return (
                    <React.Fragment key={item.id}>
                      <TableRow hover role="checkbox" tabIndex={-1} onClick={() => handleRowClickToggle(item.id)}>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          {item.customerName}
                        </TableCell>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          <button
                            style={{
                              fontSize: 10.7,
                              border: "2px solid rgb(126, 110, 228)",
                              backgroundColor: "white",
                              borderRadius: "1.2rem",
                              cursor: "auto",
                            }}
                          >
                            <FaMobileAlt
                              style={{
                                marginRight: 3,
                                color: "rgb(126, 110, 228)",
                                marginTop: "-0.16rem",
                                fontSize: 9,
                              }}
                            />
                            {item.mobileNumber}
                          </button>
                        </TableCell>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          {item.loan}
                        </TableCell>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          {totalAmountPaid}
                        </TableCell>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          {filteredPayments.length > 0 ? 'Show Details' : 'No Payments'}
                        </TableCell>
                        <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
                          <div style={{ display: "flex" }}>
                            <Badge
                              bg="success"
                              style={{ cursor: "pointer" }}
                              onClick={() => { handleClickBookingApprove();  setId(item.id); handleRowClickItemBook(item.customerName); }}
                            >
                              Approve
                            </Badge>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
                          <Collapse in={openRows[item.id]}>
                            <Box margin={1} style={{ maxHeight: '200px', overflowY: 'auto' }}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Pay Source</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Transaction ID</TableCell>
                                    <TableCell>Details</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredPayments.map((payment) => (
                                    <TableRow key={payment.id}>
                                      <TableCell>{payment.paySource}</TableCell>
                                      <TableCell>{payment.finalAmount}</TableCell>
                                      <TableCell>{payment.transactionId}</TableCell>
                                      <TableCell>{payment.transferDetail || payment.cheqNo}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography
          style={{
            color: "rgb(126, 110, 228)",
            marginTop: 20,
            marginBottom: 3,
            marginLeft: 15.5,
            fontSize: 18,
            marginTop:35,
            fontWeight: "500",
            textAlign: "center",
          }}
        >
         Transaction Details
        </Typography>

        <TableContainer>
          <Table>
            <TableHead sx={{ borderTop: "1px solid lightgray" }}>
              <TableRow>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Name</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Flat No</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Payment Transactions</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Amount</TableCell>
                <TableCell  align={"left"}
            style={{ top: 21, fontWeight: "600" }}>Paid Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customerRes && customerRes
                .filter(item => item.payments.some(payment => payment.paidStatus === 'Rejected' || payment.paidStatus === 'Approved') && item.ProjectName===ProjectName)
                .map((item) => {
                  const filteredPayments = item.payments.filter(payment => payment.paidStatus === 'Rejected' || payment.paidStatus === 'Approved');
                  
                  return (
                    <React.Fragment key={item.id}>
                      {filteredPayments.map((payment) => (
                        <TableRow key={payment.transactionId}>
                          <TableCell>{item.customerName}</TableCell>
                          <TableCell>{item.flatNo}</TableCell>
                          <TableCell>{payment.transactionId}</TableCell>
                          <TableCell>{payment.finalAmount}</TableCell>
                          <TableCell>{payment.paidStatus}</TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredCustomerRes.flatMap(item => item.payments).filter(payment => payment.paidStatus === 'Rejected' || payment.paidStatus === 'Approved').length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

      </div>
    </TabPanel> */}

    {/* Make sure you have imported these: */}
{/* import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Chip, TablePagination, Collapse, Badge as MuiBadge } from "@mui/material"; */}
{/* import { FiSmartphone, FiChevronDown, FiChevronUp } from "react-icons/fi"; */}

<TabPanel value="2" sx={{ p: { xs: 1, sm: 3 } }}>
  <Box sx={{ width: "100%" }}>
    
    {/* ========================================================= */}
    {/* 1. DATA PREPARATION (Extracted for clean HTML)            */}
    {/* ========================================================= */}
    {(() => {
      // Safely filter Booked Customers (Those with pending payments)
      const bookedCustomersList = customerRes ? customerRes.filter(item => 
        item.payments.some(payment => payment.paidStatus === null) && 
        item.ProjectName === ProjectName
      ) : [];

      // Extract and flatten all Approved/Rejected transactions for the second table
      const resolvedTransactionsList = customerRes ? customerRes
        .filter(item => item.ProjectName === ProjectName)
        .flatMap(item => {
          const resolved = item.payments.filter(p => p.paidStatus === 'Rejected' || p.paidStatus === 'Approved');
          return resolved.map(payment => ({
            ...payment,
            customerName: item.customerName,
            flatNo: item.flatNo,
            id: item.id // Keep parent ID for keys
          }));
        }) : [];

      return (
        <>
          {/* ========================================================= */}
          {/* 2. BOOKED LEADS (PENDING PAYMENTS) TABLE                    */}
          {/* ========================================================= */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography sx={{ color: "#1B2559", fontSize: "18px", fontWeight: "800" }}>
              Booked Customers (Pending Approvals)
            </Typography>
            <Box sx={{ backgroundColor: "#EEF2FF", color: "#4318ff", px: 2, py: 0.5, borderRadius: "20px", fontSize: "12px", fontWeight: "700" }}>
              Total: {bookedCustomersList.length}
            </Box>
          </Box>

          <Paper elevation={0} sx={{ width: "100%", borderRadius: "12px", border: "1px solid #E0E5F2", overflow: "hidden", mb: 5 }}>
            <TableContainer sx={{ overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
              <Table sx={{ minWidth: 700 }}>
                <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                  <TableRow>
                    {["Name", "Mobile", "Loan", "Amount Paid", "Payments", "Actions"].map((head, idx) => (
                      <TableCell key={idx} align={head === "Actions" ? "center" : "start"} sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bookedCustomersList.map((item) => {
                    const pendingPayments = item.payments.filter(payment => payment.paidStatus === null);
                    const totalAmountPaid = pendingPayments.reduce((sum, payment) => sum + parseFloat(payment.finalAmount || 0), 0);
                    const isRowOpen = openRows[item.id];

                    return (
                      <React.Fragment key={item.id}>
                        {/* Parent Row */}
                        <TableRow 
                          hover 
                          onClick={() => handleRowClickToggle(item.id)}
                          sx={{ cursor: "pointer", "& > *": { borderBottom: "unset" } }} // Remove default border to attach child row
                        >
                          <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", whiteSpace: "nowrap" }}>
                            {item.customerName}
                          </TableCell>
                          <TableCell sx={{ padding: "14px 16px", whiteSpace: "nowrap" }}>
                            <Chip 
                              icon={<FiSmartphone size={12} style={{ color: "#4318ff" }} />} 
                              label={item.mobileNumber} 
                              size="small"
                              sx={{ backgroundColor: "#EEF2FF", color: "#4318ff", fontWeight: "600", fontSize: "11px", borderRadius: "8px" }}
                            />
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", whiteSpace: "nowrap" }}>
                            {item.loan}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#10B981", padding: "14px 16px", whiteSpace: "nowrap" }}>
                            ₹{totalAmountPaid}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px", color: "#4318ff", fontWeight: "600", padding: "14px 16px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 1 }}>
                            {pendingPayments.length > 0 ? (isRowOpen ? <><FiChevronUp /> Hide</> : <><FiChevronDown /> Show</>) : 'No Payments'}
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "14px 16px" }}>
                            <Button 
                              variant="contained" 
                              disableElevation
                              onClick={(e) => {
                                e.stopPropagation(); // Prevents the row toggle from firing when clicking approve
                                handleClickBookingApprove(); 
                                setId(item.id); 
                                handleRowClickItemBook(item.customerName); 
                              }}
                              sx={{ backgroundColor: "#10B981", color: "white", fontSize: "11px", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2, py: 0.5, "&:hover": { backgroundColor: "#059669" } }}
                            >
                              Approve
                            </Button>
                          </TableCell>
                        </TableRow>

                        {/* Collapsed Child Row (Payment Details) */}
                        <TableRow sx={{ backgroundColor: "#F8FAFC" }}>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: isRowOpen ? "1px solid #E0E5F2" : "none" }} colSpan={6}>
                            <Collapse in={isRowOpen} timeout="auto" unmountOnExit>
                              <Box sx={{ margin: 2, backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #E0E5F2", overflow: "hidden" }}>
                                <Table size="small" aria-label="purchases">
                                  <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                                    <TableRow>
                                      {["Pay Source", "Amount", "Transaction ID", "Details"].map(h => (
                                        <TableCell key={h} sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "10px", textTransform: "uppercase" }}>{h}</TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {pendingPayments.map((payment) => (
                                      <TableRow key={payment.id}>
                                        <TableCell sx={{ fontSize: "12px", fontWeight: "600", color: "#2B3674" }}>{payment.paySource}</TableCell>
                                        <TableCell sx={{ fontSize: "12px", fontWeight: "600", color: "#10B981" }}>₹{payment.finalAmount}</TableCell>
                                        <TableCell sx={{ fontSize: "12px", color: "#707eae" }}>{payment.transactionId}</TableCell>
                                        <TableCell sx={{ fontSize: "12px", color: "#707eae" }}>{payment.transferDetail || payment.cheqNo || "—"}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                  {bookedCustomersList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4, color: "#A3AED0", fontWeight: "600", fontSize: "13px", borderBottom: "1px solid #E0E5F2" }}>No pending approvals found.</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          {/* ========================================================= */}
          {/* 3. TRANSACTION HISTORY TABLE (Approved / Rejected)          */}
          {/* ========================================================= */}
          <Typography sx={{ color: "#1B2559", fontSize: "18px", fontWeight: "800", mb: 2, mt: 5 }}>
            Transaction History
          </Typography>

          <Paper elevation={0} sx={{ width: "100%", borderRadius: "12px", border: "1px solid #E0E5F2", overflow: "hidden" }}>
            <TableContainer sx={{ overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
              <Table sx={{ minWidth: 600 }}>
                <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                  <TableRow>
                    {["Name", "Flat No", "Transaction ID", "Amount", "Status"].map((head, idx) => (
                      <TableCell key={idx} align="start" sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {resolvedTransactionsList.map((payment, idx) => (
                    <TableRow hover key={`${payment.id}-${idx}`}>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {payment.customerName}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "600", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {payment.flatNo}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {payment.transactionId}
                      </TableCell>
                      <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#10B981", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        ₹{payment.finalAmount}
                      </TableCell>
                      <TableCell sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        <Box sx={{ 
                          display: "inline-block", px: 1.5, py: 0.5, borderRadius: "20px", fontSize: "11px", fontWeight: "700", textTransform: "uppercase",
                          backgroundColor: payment.paidStatus === 'Approved' ? "#F0FDF4" : "#FEF2F2",
                          color: payment.paidStatus === 'Approved' ? "#10B981" : "#DC2626"
                        }}>
                          {payment.paidStatus}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                  {resolvedTransactionsList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4, color: "#A3AED0", fontWeight: "600", fontSize: "13px" }}>No transactions found.</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={resolvedTransactionsList.length} // Safe count mapping
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ color: "#707eae", fontWeight: "600", borderTop: "1px solid #E0E5F2" }}
            />
          </Paper>

        </>
      );
    })()}
    
  </Box>
</TabPanel>

                </TabContext>
              </Box>
            </Paper>
          </div>
        }
      </div>

      {/*Blocked Approve Form*/}
{/* 
      <Dialog
        style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
        maxWidth="xl"
        open={openApproveBlockForm}
        onClose={handleCloseApproveBlockForm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div style={{ width: "37rem" }}>
            <Form
              noValidate
              validated={ValidatedtaBlockApproveForm}
              onSubmit={formValidationForBlockApprove}
            >
              <div className="mb-4 mt-1">
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    color: "rgb(126, 110, 228)",
                    fontSize: 21,
                  }}
                >
                  Blocked Approve
                </Typography>
              </div>
              <TableContainer component={Paper} style={{ marginBottom: '1rem' }}>
              <Table>
      <TableHead>
        <TableRow>
          <TableCell>Customer Name</TableCell>
          <TableCell >Total Amount</TableCell>
          <TableCell >GST Percentage</TableCell>
          
          <TableCell >GST Amount</TableCell>
          
        
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredItems.map((row) => (
          <React.Fragment key={row.id}>
          
            <TableRow>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.blockTotal}</TableCell>
              <TableCell>{row.gstPercentage || 'N/A'}</TableCell>
              
              <TableCell>{row.gstAmount || 'N/A'}</TableCell>
            </TableRow>

        
            <TableRow >
              <TableCell colSpan={3}>
                <div >
                 
                  {row.bank_amtPaid && paymentStatus[row.id]?.bank !== 'Approved' && paymentStatus[row.id]?.bank !== 'Rejected' && (
                    <div className="shadow mb-3 p-3">
                          <div className='d-flex flex-row align-items-center justify-content-between'>
                      <Typography>
                        Bank Payment: ₹{row.bank_amtPaid}
                        <span>Transaction ID: {row.bank_transactionId}</span>
                      </Typography>
                     
                       <DownloadLink href={row.bank_screenshot} download target="_blank" rel="noopener noreferrer">
                       Bank Screenshot
                            </DownloadLink>
                      </div>
                      <TextField
                        type="datetime-local"
                        value={inputValues[row.id]?.bank_approvalDate || ''}
                        onChange={(e) => handleInputChange(row.id, 'bank', 'approvalDate', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <TextField
                        label="Bank Comment"
                        value={inputValues[row.id]?.bank_comment || ''}
                        onChange={(e) => handleInputChange(row.id, 'bank', 'comment', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleApproveReject(row.id, 'bank', 'approve')}
                         
                        >
                          Approve Bank
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleApproveReject(row.id, 'bank', 'reject')}
                         
                        >
                          Reject Bank
                        </Button>
                      </div>
                    </div>
                  )}


                  {row.cheque_amtPaid && paymentStatus[row.id]?.cheque !== 'Approved' && paymentStatus[row.id]?.cheque !== 'Rejected' && (
                    <div className="shadow mb-3 p-3">
                         <div className='d-flex flex-row align-items-center justify-content-between'>
                      <Typography >
                        Cheque Payment: ₹{row.cheque_amtPaid}
                        <span>Cheque Number: {row.cheque_chequeNumber}</span>
                      </Typography>
                
                       <DownloadLink href={row.cheque_chequeImage} download target="_blank" rel="noopener noreferrer">
                       Cheque Screenshot
                            </DownloadLink>
                      </div>
                      <TextField
                        type="datetime-local"
                        value={inputValues[row.id]?.cheque_approvalDate || ''}
                        onChange={(e) => handleInputChange(row.id, 'cheque', 'approvalDate', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <TextField
                        label="Cheque Comment"
                        value={inputValues[row.id]?.cheque_comment || ''}
                        onChange={(e) => handleInputChange(row.id, 'cheque', 'comment', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleApproveReject(row.id, 'cheque', 'approve')}
                        
                        >
                          Approve Cheque
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleApproveReject(row.id, 'cheque', 'reject')}
                     
                        >
                          Reject Cheque
                        </Button>
                      </div>
                    </div>
                  )}

  
                  {row.online_amtPaid && paymentStatus[row.id]?.online !== 'Approved' && paymentStatus[row.id]?.online !== 'Rejected' && (
                    <div className="shadow mb-3 p-3">
                   <div className='d-flex flex-row align-items-center justify-content-between'>
                      <Typography >
                        Online Payment: ₹{row.online_amtPaid}
                        <span>Transfer Details: {row.online_transferDetails}</span>
                      </Typography>
                   
                       <DownloadLink href={row.online_screenshot} download target="_blank" rel="noopener noreferrer">
                       Online Screenshot
                            </DownloadLink>

                      </div>
                      <TextField
                        type="datetime-local"
                        value={inputValues[row.id]?.online_approvalDate || ''}
                        onChange={(e) => handleInputChange(row.id, 'online', 'approvalDate', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <TextField
                        label="Online Comment"
                        value={inputValues[row.id]?.online_comment || ''}
                        onChange={(e) => handleInputChange(row.id, 'online', 'comment', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleApproveReject(row.id, 'online', 'approve')}
                 
                        >
                          Approve Online
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleApproveReject(row.id, 'online', 'reject')}
              
                        >
                          Reject Online
                        </Button>
                      </div>
                    </div>
                  )}

          
                  {row.upi_amtPaid && paymentStatus[row.id]?.upi !== 'Approved' && paymentStatus[row.id]?.upi !== 'Rejected' && (
                    <div className="shadow mb-3 p-3">
                       <div className='d-flex flex-row align-items-center justify-content-between'>
                      <Typography >
                        UPI Payment: ₹{row.upi_amtPaid}
                        <span>Transaction ID: {row.upi_transactionId}</span>
                      </Typography>
                    
                      <DownloadLink href={row.upi_screenshot} download target="_blank" rel="noopener noreferrer">
                      UPI Screenshot
                            </DownloadLink>
                      </div>
                      <TextField
                        type="datetime-local"
                        value={inputValues[row.id]?.upi_approvalDate || ''}
                        onChange={(e) => handleInputChange(row.id, 'upi', 'approvalDate', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <TextField
                        label="UPI Comment"
                        value={inputValues[row.id]?.upi_comment || ''}
                        onChange={(e) => handleInputChange(row.id, 'upi', 'comment', e.target.value)}
                        style={{ marginBottom: '8px', width: '100%' }}
                      />
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleApproveReject(row.id, 'upi', 'approve')}
                
                        >
                          Approve UPI
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleApproveReject(row.id, 'upi', 'reject')}
                         
                        >
                          Reject UPI
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
    </TableContainer>

              <div className="d-flex">
              
                <div>
                  <Button
                    onClick={() => {
                      setOpenApproveBlockForm(false);
                      setValidatedBlockApproveForm(false);
                      setCloseFunction()
                    }}
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "gray",
                      color: "white",
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </DialogContent>
      </Dialog> */}
      {/* Make sure you import these: */}
{/* import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Paper, Button, Grid, Divider, TextField } from "@mui/material"; */}
{/* import { FiDownloadCloud } from "react-icons/fi"; */}

<Dialog
  open={openApproveBlockForm}
  onClose={handleCloseApproveBlockForm}
  maxWidth="md" // MUI's responsive max-width (looks great on desktop, scales down on mobile)
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: "16px",
      borderTop: "8px solid #4318ff", // Premium purple top border
      backgroundColor: "#F8F9FF", // Very soft background to make white cards pop
    }
  }}
>
  {/* PREMIUM HEADER */}
  <DialogTitle sx={{ display: 'flex', justifyContent: 'center', pt: 3, pb: 1 }}>
    <Typography sx={{ color: "#1B2559", fontSize: "24px", fontWeight: "800", letterSpacing: "-0.5px" }}>
      Payment Approval Action
    </Typography>
  </DialogTitle>
  
  <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
    <form noValidate onSubmit={formValidationForBlockApprove}>
      
      {filteredItems.map((row) => (
        <Box key={row.id} sx={{ mb: 4 }}>
          
          {/* --- 1. CUSTOMER SUMMARY CARD --- */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px solid #E0E5F2", mb: 3, backgroundColor: "#ffffff" }}>
            <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 2 }}>
              Customer Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={3}>
                <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "600" }}>Name</Typography>
                <Typography sx={{ color: "#1B2559", fontSize: "15px", fontWeight: "700" }}>{row.name}</Typography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "600" }}>Total Block</Typography>
                <Typography sx={{ color: "#10B981", fontSize: "15px", fontWeight: "800" }}>₹{row.blockTotal}</Typography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "600" }}>GST %</Typography>
                <Typography sx={{ color: "#1B2559", fontSize: "15px", fontWeight: "700" }}>{row.gstPercentage || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "600" }}>GST Amount</Typography>
                <Typography sx={{ color: "#1B2559", fontSize: "15px", fontWeight: "700" }}>{row.gstAmount ? `₹${row.gstAmount}` : 'N/A'}</Typography>
              </Grid>
            </Grid>
          </Paper>

          {/* --- 2. PENDING PAYMENT ACTION CARDS --- */}
          
          {/* BANK PAYMENT CARD */}
          {row.bank_amtPaid && paymentStatus[row.id]?.bank !== 'Approved' && paymentStatus[row.id]?.bank !== 'Rejected' && (
            <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px dashed #4318ff", backgroundColor: "#F4F7FE", mb: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3, gap: 2 }}>
                <Box>
                  <Typography sx={{ color: "#4318ff", fontSize: "16px", fontWeight: "800" }}>Bank Transfer: ₹{row.bank_amtPaid}</Typography>
                  <Typography sx={{ color: "#707eae", fontSize: "13px", fontWeight: "500" }}>Txn ID: {row.bank_transactionId}</Typography>
                </Box>
                <Button 
                  component="a" href={row.bank_screenshot} target="_blank" rel="noopener noreferrer" download
                  startIcon={<FiDownloadCloud />} 
                  sx={{ backgroundColor: "#ffffff", color: "#4318ff", border: "1px solid #4318ff", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2 }}
                >
                  Receipt
                </Button>
              </Box>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth type="datetime-local" size="small"
                    label="Approval Date" InputLabelProps={{ shrink: true }}
                    value={inputValues[row.id]?.bank_approvalDate || ''}
                    onChange={(e) => handleInputChange(row.id, 'bank', 'approvalDate', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Admin Comment"
                    value={inputValues[row.id]?.bank_comment || ''}
                    onChange={(e) => handleInputChange(row.id, 'bank', 'comment', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'bank', 'approve')} sx={{ backgroundColor: "#10B981", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#059669" } }}>
                  Approve Bank
                </Button>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'bank', 'reject')} sx={{ backgroundColor: "#FEF2F2", color: "#DC2626", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#FEE2E2" } }}>
                  Reject
                </Button>
              </Box>
            </Paper>
          )}

          {/* CHEQUE PAYMENT CARD */}
          {row.cheque_amtPaid && paymentStatus[row.id]?.cheque !== 'Approved' && paymentStatus[row.id]?.cheque !== 'Rejected' && (
            <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px dashed #4318ff", backgroundColor: "#F4F7FE", mb: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3, gap: 2 }}>
                <Box>
                  <Typography sx={{ color: "#4318ff", fontSize: "16px", fontWeight: "800" }}>Cheque: ₹{row.cheque_amtPaid}</Typography>
                  <Typography sx={{ color: "#707eae", fontSize: "13px", fontWeight: "500" }}>Cheque No: {row.cheque_chequeNumber}</Typography>
                </Box>
                <Button 
                  component="a" href={row.cheque_chequeImage} target="_blank" rel="noopener noreferrer" download
                  startIcon={<FiDownloadCloud />} 
                  sx={{ backgroundColor: "#ffffff", color: "#4318ff", border: "1px solid #4318ff", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2 }}
                >
                  Receipt
                </Button>
              </Box>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth type="datetime-local" size="small"
                    label="Approval Date" InputLabelProps={{ shrink: true }}
                    value={inputValues[row.id]?.cheque_approvalDate || ''}
                    onChange={(e) => handleInputChange(row.id, 'cheque', 'approvalDate', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Admin Comment"
                    value={inputValues[row.id]?.cheque_comment || ''}
                    onChange={(e) => handleInputChange(row.id, 'cheque', 'comment', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'cheque', 'approve')} sx={{ backgroundColor: "#10B981", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#059669" } }}>
                  Approve Cheque
                </Button>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'cheque', 'reject')} sx={{ backgroundColor: "#FEF2F2", color: "#DC2626", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#FEE2E2" } }}>
                  Reject
                </Button>
              </Box>
            </Paper>
          )}

          {/* ONLINE PAYMENT CARD */}
          {row.online_amtPaid && paymentStatus[row.id]?.online !== 'Approved' && paymentStatus[row.id]?.online !== 'Rejected' && (
            <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px dashed #4318ff", backgroundColor: "#F4F7FE", mb: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3, gap: 2 }}>
                <Box>
                  <Typography sx={{ color: "#4318ff", fontSize: "16px", fontWeight: "800" }}>Online Transfer: ₹{row.online_amtPaid}</Typography>
                  <Typography sx={{ color: "#707eae", fontSize: "13px", fontWeight: "500" }}>Details: {row.online_transferDetails}</Typography>
                </Box>
                <Button 
                  component="a" href={row.online_screenshot} target="_blank" rel="noopener noreferrer" download
                  startIcon={<FiDownloadCloud />} 
                  sx={{ backgroundColor: "#ffffff", color: "#4318ff", border: "1px solid #4318ff", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2 }}
                >
                  Receipt
                </Button>
              </Box>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth type="datetime-local" size="small"
                    label="Approval Date" InputLabelProps={{ shrink: true }}
                    value={inputValues[row.id]?.online_approvalDate || ''}
                    onChange={(e) => handleInputChange(row.id, 'online', 'approvalDate', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Admin Comment"
                    value={inputValues[row.id]?.online_comment || ''}
                    onChange={(e) => handleInputChange(row.id, 'online', 'comment', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'online', 'approve')} sx={{ backgroundColor: "#10B981", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#059669" } }}>
                  Approve Online
                </Button>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'online', 'reject')} sx={{ backgroundColor: "#FEF2F2", color: "#DC2626", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#FEE2E2" } }}>
                  Reject
                </Button>
              </Box>
            </Paper>
          )}

          {/* UPI PAYMENT CARD */}
          {row.upi_amtPaid && paymentStatus[row.id]?.upi !== 'Approved' && paymentStatus[row.id]?.upi !== 'Rejected' && (
            <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px dashed #4318ff", backgroundColor: "#F4F7FE", mb: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3, gap: 2 }}>
                <Box>
                  <Typography sx={{ color: "#4318ff", fontSize: "16px", fontWeight: "800" }}>UPI Payment: ₹{row.upi_amtPaid}</Typography>
                  <Typography sx={{ color: "#707eae", fontSize: "13px", fontWeight: "500" }}>Txn ID: {row.upi_transactionId}</Typography>
                </Box>
                <Button 
                  component="a" href={row.upi_screenshot} target="_blank" rel="noopener noreferrer" download
                  startIcon={<FiDownloadCloud />} 
                  sx={{ backgroundColor: "#ffffff", color: "#4318ff", border: "1px solid #4318ff", fontWeight: "700", textTransform: "none", borderRadius: "8px", px: 2 }}
                >
                  Receipt
                </Button>
              </Box>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth type="datetime-local" size="small"
                    label="Approval Date" InputLabelProps={{ shrink: true }}
                    value={inputValues[row.id]?.upi_approvalDate || ''}
                    onChange={(e) => handleInputChange(row.id, 'upi', 'approvalDate', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Admin Comment"
                    value={inputValues[row.id]?.upi_comment || ''}
                    onChange={(e) => handleInputChange(row.id, 'upi', 'comment', e.target.value)}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'upi', 'approve')} sx={{ backgroundColor: "#10B981", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#059669" } }}>
                  Approve UPI
                </Button>
                <Button fullWidth variant="contained" disableElevation onClick={() => handleApproveReject(row.id, 'upi', 'reject')} sx={{ backgroundColor: "#FEF2F2", color: "#DC2626", fontWeight: "700", py: 1, "&:hover": { backgroundColor: "#FEE2E2" } }}>
                  Reject
                </Button>
              </Box>
            </Paper>
          )}

        </Box>
      ))}

      {/* --- SUBMIT / CLOSE ACTION BUTTONS --- */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, pt: 3, borderTop: "1px solid #E0E5F2" }}>
        <Button 
          variant="contained"
          onClick={() => {
            setOpenApproveBlockForm(false);
            setValidatedBlockApproveForm(false);
            setCloseFunction();
          }}
          sx={{ 
            backgroundColor: "#2B3674", // Premium deep slate
            color: "white", 
            px: 5, py: 1.5, 
            borderRadius: "8px", 
            fontWeight: "700", 
            textTransform: "none",
            "&:hover": { backgroundColor: "#1B2559" }
          }}
        >
          Submit Updates
        </Button>
      </Box>

    </form>
  </DialogContent>
</Dialog>

      {/*Blocked Reject Form*/}

      <Dialog
        style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
        maxWidth="xl"
        open={openRejectForm}
        onClose={handleCloseReject}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div style={{ width: "37rem" }}>
            <Form
              noValidate
              validated={Validatedtabcb}
              onSubmit={formValidationReject}
            >
              <div className="mb-4 mt-1">
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    color: "rgb(126, 110, 228)",
                    fontSize: 21,
                  }}
                >
                  Blocked Reject
                </Typography>
              </div>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Typography style={{ color: "gray", fontSize: 13 }}>
                    Date of Reject *
                  </Typography>
                  <Form.Control
                    required
                    onChange={(e) => setDataForReject(e.target.value)}
                    type="datetime-local"
                    style={{ padding: "0.42rem", marginBottom: 14 }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Valid Name
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="12" controlId="validationCustom01">
                  <Typography style={{ color: "gray", fontSize: 13 }}>
                    Comment Box
                  </Typography>
                  <Form.Control
                    re
                    onChange={(e) => setCommentForReject(e.target.value)}
                    required
                    as="textarea"
                    style={{ padding: "0.42rem", marginBottom: 14 }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Valid Comment
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div className="d-flex">
                <div>
                  <Button
                    type="submit"
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "rgb(126, 110, 228)",
                      color: "white",
                      marginRight: 3,
                    }}
                  >
                    Submit
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={() => {
                      setOpenReject(false);
                      setValidatedtabcb(false);
                    }}
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "gray",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </DialogContent>
      </Dialog>

      {/* Booking Approve From*/}

      {/* <Dialog
        style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
        maxWidth="xl"
        open={openApproveBookingForm}
        onClose={handleCloseApproveBookingForm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div style={{ width: "37rem" }}>
            <Form
              noValidate
              validated={ValidatedtaBookingForm}
              onSubmit={formValidationApproveBookingForm}
            >
              <div className="mb-4 mt-1">
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    color: "rgb(126, 110, 228)",
                    fontSize: 21,
                  }}
                >
                  Booking Approve
                </Typography>
              </div>

              {error && (
            <Typography color="error" style={{ marginBottom: '1rem' }}>
              {error}
            </Typography>
          )}

          {loading && <CircularProgress style={{ display: 'block', margin: '0 auto' }} />}

            
              {filteredItemsBook.map((item, index) => (
            <div key={index} style={{ marginBottom: '2rem' }}>
              <Typography variant="h6" style={{ marginBottom: '1rem' }}>
                Customer Name: {item.customerName || "N/A"}
              </Typography>

              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Pay Source</TableCell>
                      <TableCell>Transaction ID</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(item.payments || []).map((payment, paymentIndex) => (
                      <TableRow key={paymentIndex}>
                        <TableCell>{payment.paySource || "N/A"}</TableCell>
                        <TableCell>{payment.transactionId || "N/A"}</TableCell>
                        <TableCell>{payment.createdDate ? new Date(payment.createdDate).toLocaleDateString() : "N/A"}</TableCell>
                        <TableCell>{payment.finalAmount || "N/A"}</TableCell>
                        <TableCell className="d-flex flex-row align-items-center">
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ marginRight: '0.5rem' }}
                            onClick={() => handleApproval(index, paymentIndex)}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleRejection(index, paymentIndex)}
                          >
                            Reject
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </div>
))}


             
                <div>
                  <Button
                    onClick={() => {
                      setApproveBookingForm(false);
                      setValidatedBookingForm(false);
                    }}
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "gray",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
           
       
            </Form>
            </div>
       
        </DialogContent>
      </Dialog> */}
{/* 
<Dialog
  style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
  maxWidth="xl"
  open={openApproveBookingForm}
  onClose={handleCloseApproveBookingForm}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogContent>
    <div style={{ width: "45rem" }}>
      <Form
        noValidate
        validated={ValidatedtaBookingForm}
        onSubmit={formValidationApproveBookingForm}
      >
        <div className="mb-4 mt-1">
          <Typography
            style={{
              textAlign: "center",
              fontWeight: "500",
              color: "rgb(126, 110, 228)",
              fontSize: 21,
            }}
          >
            Booking Approve
          </Typography>
        </div>

        {error && (
          <Typography color="error" style={{ marginBottom: '1rem' }}>
            {error}
          </Typography>
        )}

        

        {filteredItemsBook
        .filter(item => item.payments.some(payment => payment.paidStatus !== 'Approved'))
        .map((item, index) => (
          <div key={index} style={{ marginBottom: '2rem' }}>
            <div className="d-flex flex-row">
            <Typography variant="h6" style={{ marginBottom: '1rem' }}>
              Customer Name: {item.customerName || "N/A"}
            </Typography>
            <Typography variant="h6" style={{ marginBottom: '1rem',marginLeft:'1rem' }}>
              flatNo: {item.flatNo || "N/A"}
            </Typography>
            </div>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Pay Source</TableCell>
                    <TableCell>Transaction ID</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Screenshot</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(item.payments || [])
                    .filter(payment => payment.paidStatus !== 'Approved')
                    .map((payment, paymentIndex) => (
                      <TableRow key={paymentIndex}>
                        <TableCell>{payment.paySource || "N/A"}</TableCell>
                        <TableCell>
                          {payment.paySource === 'Cheque' ? payment.cheqNo || "N/A" : payment.transactionId || "N/A"}
                        </TableCell>
                        <TableCell>{payment.createdDate ? new Date(payment.createdDate).toLocaleDateString() : "N/A"}</TableCell>
                        <TableCell>{payment.finalAmount || "N/A"}</TableCell>
                
                        <TableCell className="d-flex flex-row align-items-center">

                          {payment.bank_screenshot && (
                            <DownloadLink href={payment.bank_screenshot} download target="_blank" rel="noopener noreferrer">
                           Bank Screenshot
                            </DownloadLink>
                          )}
                          {payment.cheque_image && (
                            <DownloadLink href={payment.cheque_image} download target="_blank" rel="noopener noreferrer">
                       Cheque Image
                            </DownloadLink>  
                          )}
                   
           
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ marginRight: '0.5rem' }}
                            onClick={() => handleApproval(index, paymentIndex)}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleRejection(index, paymentIndex)}
                          >
                            Reject
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ))}

        <div>
          <Button
            onClick={() => {
              setApproveBookingForm(false);
              setValidatedBookingForm(false);
            }}
            style={{
              width: "9rem",
              height: "2.3rem",
              backgroundColor: "gray",
              color: "white",
            }}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  </DialogContent>
</Dialog> */}


{/* Make sure you import these: */}
{/* import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Paper, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"; */}
{/* import { FiDownloadCloud } from "react-icons/fi"; */}

<Dialog
  open={openApproveBookingForm}
  onClose={handleCloseApproveBookingForm}
  maxWidth="md" // Responsive sizing: expands on desktop, shrinks neatly on mobile
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: "16px",
      borderTop: "8px solid #4318ff", // Premium purple accent line
      backgroundColor: "#F8F9FF", // Soft background to make the white cards pop
    }
  }}
>
  {/* PREMIUM HEADER */}
  <DialogTitle sx={{ display: 'flex', justifyContent: 'center', pt: 3, pb: 1 }}>
    <Typography sx={{ color: "#1B2559", fontSize: "24px", fontWeight: "800", letterSpacing: "-0.5px" }}>
      Booking Approval
    </Typography>
  </DialogTitle>

  <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
    <form noValidate validated={ValidatedtaBookingForm} onSubmit={formValidationApproveBookingForm}>
      
      {error && (
        <Box sx={{ backgroundColor: "#FEF2F2", border: "1px solid #FEE2E2", borderRadius: "8px", p: 2, mb: 3 }}>
          <Typography sx={{ color: "#DC2626", fontSize: "14px", fontWeight: "600", textAlign: "center" }}>
            {error}
          </Typography>
        </Box>
      )}

      {filteredItemsBook
        .filter(item => item.payments.some(payment => payment.paidStatus !== 'Approved'))
        .map((item, index) => (
          <Paper key={index} elevation={0} sx={{ p: { xs: 2, sm: 3 }, mb: 4, borderRadius: "12px", border: "1px solid #E0E5F2", backgroundColor: "#ffffff" }}>
            
            {/* CUSTOMER DETAILS HEADER */}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1, sm: 4 }, mb: 3, pb: 2, borderBottom: "1px dashed #E0E5F2" }}>
              <Box>
                <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" }}>Customer Name</Typography>
                <Typography sx={{ color: "#1B2559", fontSize: "16px", fontWeight: "800" }}>{item.customerName || "N/A"}</Typography>
              </Box>
              <Box>
                <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" }}>Flat No.</Typography>
                <Typography sx={{ color: "#4318ff", fontSize: "16px", fontWeight: "800" }}>{item.flatNo || "N/A"}</Typography>
              </Box>
            </Box>

            {/* PAYMENTS TABLE */}
            <TableContainer sx={{ borderRadius: "8px", border: "1px solid #E0E5F2", overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
                  <TableRow>
                    {["Pay Source", "Transaction ID", "Date", "Amount", "Receipt", "Action"].map((head, idx) => (
                      <TableCell key={idx} align={head === "Action" ? "center" : "start"} sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(item.payments || [])
                    .filter(payment => payment.paidStatus !== 'Approved')
                    .map((payment, paymentIndex) => (
                      <TableRow hover key={paymentIndex}>
                        <TableCell sx={{ fontSize: "13px", fontWeight: "600", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          {payment.paySource || "N/A"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          {payment.paySource === 'Cheque' ? payment.cheqNo || "N/A" : payment.transactionId || "N/A"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "13px", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          {payment.createdDate ? new Date(payment.createdDate).toLocaleDateString() : "N/A"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#10B981", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          ₹{payment.finalAmount || "0"}
                        </TableCell>
                        
                        {/* RECEIPT DOWNLOAD */}
                        <TableCell sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          {(payment.bank_screenshot || payment.cheque_image) ? (
                            <Button 
                              component="a" 
                              href={payment.bank_screenshot || payment.cheque_image} 
                              download target="_blank" rel="noopener noreferrer"
                              startIcon={<FiDownloadCloud />}
                              size="small"
                              sx={{ color: "#4318ff", backgroundColor: "#EEF2FF", fontWeight: "600", fontSize: "11px", textTransform: "none", borderRadius: "6px", "&:hover": { backgroundColor: "#E0E5F2" } }}
                            >
                              Download
                            </Button>
                          ) : (
                            <Typography sx={{ fontSize: "12px", color: "#A3AED0" }}>No File</Typography>
                          )}
                        </TableCell>

                        {/* APPROVE / REJECT ACTIONS */}
                        <TableCell align="center" sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                            <Button 
                              variant="contained" 
                              disableElevation
                              onClick={() => handleApproval(index, paymentIndex)}
                              sx={{ backgroundColor: "#10B981", color: "white", fontSize: "11px", fontWeight: "700", textTransform: "none", borderRadius: "6px", px: 2, minWidth: "80px", "&:hover": { backgroundColor: "#059669" } }}
                            >
                              Approve
                            </Button>
                            <Button 
                              variant="contained" 
                              disableElevation
                              onClick={() => handleRejection(index, paymentIndex)}
                              sx={{ backgroundColor: "#FEF2F2", color: "#DC2626", fontSize: "11px", fontWeight: "700", textTransform: "none", borderRadius: "6px", px: 2, minWidth: "80px", "&:hover": { backgroundColor: "#FEE2E2" } }}
                            >
                              Reject
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
      ))}

      {/* --- CANCEL / SUBMIT FOOTER --- */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button 
          onClick={() => {
            setApproveBookingForm(false);
            setValidatedBookingForm(false);
          }}
          sx={{ 
            backgroundColor: "#F4F7FE", 
            color: "#4318ff", 
            px: 4, py: 1.5, 
            borderRadius: "8px", 
            fontWeight: "700", 
            textTransform: "none",
            transition: "all 0.2s",
            "&:hover": { backgroundColor: "#E9EDF7" }
          }}
        >
          Cancel & Close
        </Button>
      </Box>

    </form>
  </DialogContent>
</Dialog>

      {/*Booking Reject From*/}

      <Dialog
        style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
        maxWidth="xl"
        open={openBookRejectForm}
        onClose={handleCloseBookReject}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div style={{ width: "37rem" }}>
            <Form
              noValidate
              validated={Validatedtabcb}
              onSubmit={formValidationRejectBook}
            >
              <div className="mb-4 mt-1">
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    color: "rgb(126, 110, 228)",
                    fontSize: 21,
                  }}
                >
                  Booking Reject
                </Typography>
              </div>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Typography style={{ color: "gray", fontSize: 13 }}>
                    Date of Reject *
                  </Typography>
                  <Form.Control
                    required
                    onChange={(e) => setDataForBookingReject(e.target.value)}
                    type="datetime-local"
                    style={{ padding: "0.42rem", marginBottom: 14 }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Valid Name
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="12" controlId="validationCustom01">
                  <Typography style={{ color: "gray", fontSize: 13 }}>
                    Comment Box
                  </Typography>
                  <Form.Control
                    re
                    onChange={(e) => setCommentForBookingReject(e.target.value)}
                    required
                    as="textarea"
                    style={{ padding: "0.42rem", marginBottom: 14 }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Valid Permanent Address
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div className="d-flex">
                <div>
                  <Button
                    type="submit"
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "rgb(126, 110, 228)",
                      color: "white",
                      marginRight: 3,
                    }}
                  >
                    Submit
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={() => {
                      setOpenBookRejectForm(false);
                      setValidatedtabcb(false);
                    }}
                    style={{
                      width: "9rem",
                      height: "2.3rem",
                      backgroundColor: "gray",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PreSales;



// {filteredItems.map((row) => (
//   <TableRow key={row.id}>
//     <TableCell>{row.name}</TableCell>
//     <TableCell style={{ fontSize: 12 }}>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        
//         {/* Bank Payment */}
//         {row.bank_amtPaid && (
//           <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px' }}>
//             <Typography variant="body1">Bank: ₹{row.bank_amtPaid}</Typography>
//             <TextField
//               type="datetime-local"
//               label="Bank Approval Date"
//               value={inputValues[row.id]?.bank_approvalDate || ''}
//               onChange={(e) => handleInputChange(row.id, 'bank', 'approvalDate', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <TextField
//               label="Bank Comment"
//               value={inputValues[row.id]?.bank_comment || ''}
//               onChange={(e) => handleInputChange(row.id, 'bank', 'comment', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => handleApproveReject(row.id, 'bank', 'approve')}
//               >
//                 Approve Bank
//               </Button>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={() => handleApproveReject(row.id, 'bank', 'reject')}
//               >
//                 Reject Bank
//               </Button>
//             </div>
//           </div>
//         )}

//         {/* Cheque Payment */}
//         {row.cheque_amtPaid && (
//           <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px' }}>
//             <Typography variant="body1">Cheque: ₹{row.cheque_amtPaid}</Typography>
//             <TextField
//               type="datetime-local"
//               label="Cheque Approval Date"
//               value={inputValues[row.id]?.cheque_approvalDate || ''}
//               onChange={(e) => handleInputChange(row.id, 'cheque', 'approvalDate', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <TextField
//               label="Cheque Comment"
//               value={inputValues[row.id]?.cheque_comment || ''}
//               onChange={(e) => handleInputChange(row.id, 'cheque', 'comment', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => handleApproveReject(row.id, 'cheque', 'approve')}
//               >
//                 Approve Cheque
//               </Button>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={() => handleApproveReject(row.id, 'cheque', 'reject')}
//               >
//                 Reject Cheque
//               </Button>
//             </div>
//           </div>
//         )}

//         {/* Online Payment */}
//         {row.online_amtPaid && (
//           <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px' }}>
//             <Typography variant="body1">Online: ₹{row.online_amtPaid}</Typography>
//             <TextField
//               type="datetime-local"
//               label="Online Approval Date"
//               value={inputValues[row.id]?.online_approvalDate || ''}
//               onChange={(e) => handleInputChange(row.id, 'online', 'approvalDate', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <TextField
//               label="Online Comment"
//               value={inputValues[row.id]?.online_comment || ''}
//               onChange={(e) => handleInputChange(row.id, 'online', 'comment', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => handleApproveReject(row.id, 'online', 'approve')}
//               >
//                 Approve Online
//               </Button>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={() => handleApproveReject(row.id, 'online', 'reject')}
//               >
//                 Reject Online
//               </Button>
//             </div>
//           </div>
//         )}

//         {/* UPI Payment */}
//         {row.upi_amtPaid && (
//           <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px' }}>
//             <Typography variant="body1">UPI: ₹{row.upi_amtPaid}</Typography>
//             <TextField
//               type="datetime-local"
//               label="UPI Approval Date"
//               value={inputValues[row.id]?.upi_approvalDate || ''}
//               onChange={(e) => handleInputChange(row.id, 'upi', 'approvalDate', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <TextField
//               label="UPI Comment"
//               value={inputValues[row.id]?.upi_comment || ''}
//               onChange={(e) => handleInputChange(row.id, 'upi', 'comment', e.target.value)}
//               style={{ marginBottom: 8 }}
//             />
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => handleApproveReject(row.id, 'upi', 'approve')}
//               >
//                 Approve UPI
//               </Button>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={() => handleApproveReject(row.id, 'upi', 'reject')}
//               >
//                 Reject UPI
//               </Button>
//             </div>
//           </div>
//         )}

//       </div>
//     </TableCell>
//     <TableCell>
//       {/* Optional additional actions */}
//     </TableCell>
//   </TableRow>
//))}



{/* <TabPanel value="1">
<div style={{ width: "58rem" }}>
  <Typography
    style={{
      color: "rgba(41, 16, 105, 1)",
      marginBottom: 3,
      marginLeft: 15.5,
      fontSize: 18,
      color: "gray",
      fontWeight: "500",
      textAlign: "center",
    }}
  >
    Blocked
  </Typography>
  <div style={{ fontWeight: "bold" }}>
    Total Blocked: {customerRessib .filter(item => {
// Exclude items where overall_status is 'Approved'
if (item.overall_status === 'Approved') {
return false;
}

// Check if any payment amount is provided
const hasPayment = 
item.bank_amtPaid ||
item.cheque_amtPaid ||
item.online_amtPaid ||
item.upi_amtPaid;

// Check if any payment method has been approved
const hasApprovedPayment = 
(item.bank_status === 'Approved' && item.bank_amtPaid) ||
(item.cheque_status === 'Approved' && item.cheque_amtPaid) ||
(item.online_status === 'Approved' && item.online_amtPaid) ||
(item.upi_status === 'Approved' && item.upi_amtPaid);

// Exclude items where all payment amounts are missing or all payments are approved
return hasPayment && !hasApprovedPayment;
}).length}
  </div>

  <Table style={{ position: "relative", top: "1.3rem" }}>
    <TableHead sx={{ borderTop: "1px solid lightgray" }}>
      <TableRow>
        <TableCell
          align={"start"}
          style={{
            minWidth: 0,
            fontSize: 14,
            fontWeight: "600",
          }}
        >
          Name
        </TableCell>
        <TableCell
          align={"left"}
          style={{ top: 57, fontWeight: "600" }}
        >
          Mobile
        </TableCell>

        <TableCell
          align={"left"}
          style={{ top: 21, fontWeight: "600" }}
        >
          Aadhar
        </TableCell>

        <TableCell
          align={"left"}
          style={{ top: 21, fontWeight: "600" }}
        >
          Address
        </TableCell>

        <TableCell
          align={"center"}
          style={{ top: 21, fontWeight: "600", width: 18 }}
        >
          Action
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
{customerRessib &&
customerRessib
.filter(item => {
// Exclude items where overall_status is 'Approved'
if (item.overall_status === 'Approved') {
return false;
}

// Check if any payment amount is provided
const hasPayment = 
item.bank_amtPaid ||
item.cheque_amtPaid ||
item.online_amtPaid ||
item.upi_amtPaid;

// Check if any payment method has been approved
const hasApprovedPayment = 
(item.bank_status === 'Approved' && item.bank_amtPaid) ||
(item.cheque_status === 'Approved' && item.cheque_amtPaid) ||
(item.online_status === 'Approved' && item.online_amtPaid) ||
(item.upi_status === 'Approved' && item.upi_amtPaid);

// Exclude items where all payment amounts are missing or all payments are approved
return hasPayment && !hasApprovedPayment;
})
.map(item => (
<TableRow
hover
role="checkbox"
tabIndex={-1}
key={item.id}  // Changed from item.Id to item.id for consistency with the provided data
>
<TableCell
align="start"
style={{ top: 57, fontSize: 12 }}
>
{item.name}
</TableCell>
<TableCell
align="start"
style={{ top: 57, fontSize: 12 }}
>
<button
style={{
fontSize: 10.7,
border: "2px solid rgb(126, 110, 228)",
backgroundColor: "white",
borderRadius: "1.2rem",
cursor: "auto",
}}
>
<FaMobileAlt
style={{
marginRight: 3,
color: "rgb(126, 110, 228)",
marginTop: "-0.16rem",
fontSize: 9,
}}
/>
{item.mobile}
</button>
</TableCell>

<TableCell
align="start"
style={{ top: 57, fontSize: 12 }}
>
{item.aadharNo}
</TableCell>

<TableCell
align="start"
style={{ top: 57, fontSize: 12 }}
>
{item.permanentAddress}
</TableCell>
<TableCell
align="start"
style={{
top: 57,
fontSize: 12,
color: "rgb(126, 110, 228) ",
}}
>
<div style={{ display: "flex" }}>
<Badge
bg="success"
style={{ cursor: "pointer" }}
onClick={() => {
handleClickOpenApproveBlock();
handleRowClickItem(item.name);
setId(item.id); // Changed from item.Id to item.id for consistency with the provided data
}}
>
Approve
</Badge>
</div>
</TableCell>
</TableRow>
))}
</TableBody>


  </Table>

  {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                            <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                        </div> */}
// </div>
// </TabPanel> */}


{/* <TableBody>
{customerRes && 
  customerRes.filter(item => item.status !== 'approved').map((item) => {
    // Calculate total amount paid
    const totalAmountPaid = item.payments.reduce((sum, payment) => sum + parseFloat(payment.finalAmount || 0), 0);

    return (
      <React.Fragment key={item.id}>
        <TableRow hover role="checkbox" tabIndex={-1} onClick={() => handleRowClick(item.id)}>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            {item.customerName}
          </TableCell>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            <button
              style={{
                fontSize: 10.7,
                border: "2px solid rgb(126, 110, 228)",
                backgroundColor: "white",
                borderRadius: "1.2rem",
                cursor: "auto",
              }}
            >
              <FaMobileAlt
                style={{
                  marginRight: 3,
                  color: "rgb(126, 110, 228)",
                  marginTop: "-0.16rem",
                  fontSize: 9,
                }}
              />
              {item.mobileNumber}
            </button>
          </TableCell>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            {item.loan}
          </TableCell>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            {totalAmountPaid}
          </TableCell>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            {item.payments.length > 0 ? 'Show Details' : 'No Payments'}
          </TableCell>
          <TableCell align="start" style={{ top: 57, fontSize: 12 }}>
            <div style={{ display: "flex" }}>
              <Badge
                bg="success"
                style={{ cursor: "pointer" }}
                onClick={() => { handleClickBookingApprove(); setId(item.id),handleRowClickItemBook(item.customerName)}}
              >
                Approve
              </Badge>
             
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={openRows[item.id]}>
              <Box margin={1} style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Pay Source</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Transaction ID</TableCell>
                      <TableCell>Details</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item.payments.map((payment) => (
                      <TableRow key={payment.id}>
                        <TableCell>{payment.paySource}</TableCell>
                        <TableCell>{payment.finalAmount}</TableCell>
                        <TableCell>{payment.transactionId}</TableCell>
                        <TableCell>{payment.transferDetail || payment.cheqNo}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  })
}
</TableBody> */}